import { BodyText } from '@ui-components/typography/Typography'
import { MouseEvent } from 'react'
import { styled } from 'styled-components'

import { ExternalLinkIcon } from '../assets/Icons'
import { Colors } from '../global/colors'

interface FormUploadSummaryItemProps {
  fileName: string
  onClick?: () => void
  ariaLabel: string
}

const DownloadLink = styled.button<{ $isLink: boolean }>`
  display: flex;
  background: none;
  border: none;
  padding: 0;
  text-align: left;
  cursor: ${(props) => (props.$isLink ? 'pointer' : 'default')};
  justify-content: flex-start;
  align-items: center;
  color: ${Colors.TextStrongPrimary};
  text-decoration: ${(props) => (props.$isLink ? 'underline' : 'unset')};
  word-break: break-all;
`
const ColoredSpan = styled.span<{ $isLink: boolean }>`
  cursor: ${(props) => (props.$isLink ? 'pointer' : 'default')};
  color: ${(props) => (props.$isLink ? `${Colors.TextStrongPrimary}` : `${Colors.TextDefaultNeutral}`)};
`

export const FormUploadSummaryItem = ({ fileName, onClick, ariaLabel }: FormUploadSummaryItemProps) => {
  const isLink = !!onClick

  return (
    <li>
      <DownloadLink
        as={isLink ? 'button' : 'div'}
        onClick={
          isLink
            ? (e: MouseEvent<HTMLButtonElement>) => {
                e.preventDefault()
                if (isLink) {
                  onClick()
                }
              }
            : undefined
        }
        aria-label={ariaLabel}
        $isLink={isLink}
      >
        <BodyText>
          <ColoredSpan $isLink={isLink}>{fileName}</ColoredSpan>
        </BodyText>
        {isLink && <ExternalLinkIcon />}
      </DownloadLink>
    </li>
  )
}
